/*
 * La durée en mots, écrite une fois (chantier duree-a-la-minute, ticket 01) : ce qu'une tâche te
 * prend, la durée d'un rendez-vous ou d'une journée, dits de la même façon par le serveur (le
 * pourquoi d'une ligne de « Maintenant »), l'app et le MCP. Sans dépendance : l'entrée « . » du
 * paquet, l'app peut l'importer.
 */
/** « 45 min », « 1 h », « 1 h 25 », « 1 h 05 » : une durée en minutes, dite comme l'app. */
export function dureeEnMots(minutes) {
    if (minutes < 60)
        return `${minutes} min`;
    const heures = Math.floor(minutes / 60);
    const reste = minutes % 60;
    return reste ? `${heures} h ${String(reste).padStart(2, '0')}` : `${heures} h`;
}
